module.exports = __webpack_public_path__ + "5294ccbe0554f75fcec02769162477d4.pdf";